
export default {
    init($element) {
    },
    finalize($element) {
        if ($element.find('.general-text-grid')) { 
            const gridItems = document.querySelectorAll('.grid-item');

            gridItems.forEach(function(item){
                if (item.querySelector('.grid-item-text a')){
                    const link = item.querySelector('.grid-item-text a');

                    $(item).wrapInner('<a href=' + link.href + '></a>');
                }
            })
        }
    },
}



// WEBPACK FOOTER //
// ./scripts/partials/general/textGrid.js